import { connect } from 'react-redux';

import LoginRoute from './LoginRoute.js';

const isActive = a => a.active === true;

const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);

  return {
    server: activeServer,
    user: state.oidc.user,
  };
};

const ConnectedLogin = connect(
  mapStateToProps,
  null
)(LoginRoute);

export default ConnectedLogin;
